import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.6 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M.35.35c.47-.47 1.23-.47 1.7 0L10.8 9.1 19.55.35a1.201 1.201 0 1 1 1.7 1.7l-9.6 9.6c-.47.47-1.23.47-1.7 0l-9.6-9.6C-.12 1.58-.12.82.35.35"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }